import {useLeftyTemplate} from 'Event/template/Lefty'
import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import ImageAssetUploader from 'lib/asset/ImageAssetUploader'
import Title from 'lib/ui/ConfigPanel/Title'
import TextField from 'lib/ui/TextField'
import {useAttendeeVariables} from 'Event'

export default function Settings(props: {
  control: UseFormMethods['control']
  watch: UseFormMethods['watch']
}) {
  const {control} = props
  const template = useLeftyTemplate()
  const v = useAttendeeVariables()

  return (
    <>
      <Title>Dashboard Logo</Title>
      <Controller
        name="logo"
        control={control}
        defaultValue={template.logo}
        render={({onChange, value}) => (
          <ImageAssetUploader
            onChange={onChange}
            value={value}
            uploadLabel="Upload"
            canResize
            removeButtonProps={{
              'aria-label': 'remove logo',
            }}
            uploadInputProps={{
              'aria-label': 'logo upload',
            }}
            disableAutoRemove
          />
        )}
      />
      <Title>Header Background</Title>
      <Controller
        name="header.backgroundImage"
        control={control}
        defaultValue={template.header.backgroundImage}
        render={({onChange, value}) => (
          <ImageAssetUploader
            onChange={onChange}
            value={value}
            uploadLabel="Upload"
            canResize
            uploadInputProps={{
              'aria-label': 'header background upload',
            }}
            disableAutoRemove
          />
        )}
      />
      <Title>Header Text</Title>
      <Controller
        name="header.text"
        defaultValue={v(template.header.text ?? '')}
        control={control}
        render={({value, onChange}) => (
          <TextField
            fullWidth
            value={value}
            aria-label="header text"
            placeholder="Text"
            onChange={onChange}
            inputProps={{maxLength: 150}}
          />
        )}
      />
      <Title>Page Background</Title>
      <Controller
        name="pageBackground.image"
        control={control}
        defaultValue={template.pageBackground.image}
        render={({onChange, value}) => (
          <ImageAssetUploader
            onChange={onChange}
            value={value}
            uploadLabel="Upload"
            canResize
            uploadInputProps={{
              'aria-label': 'page background upload',
            }}
            disableAutoRemove
          />
        )}
      />
    </>
  )
}
